import script from "./forms.vue?vue&type=script&setup=true&lang=ts"
export * from "./forms.vue?vue&type=script&setup=true&lang=ts"

import "./forms.vue?vue&type=style&index=0&id=0cb38f98&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cb38f98"]])

export default __exports__